<div class="dark:bg-gray-700 rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <h2 class="titre2 text-white dark:text-white">{{ 'USERS_MANAGEMENT.DEACTIVATION_RESULT' | translate }}</h2>
  </div>
  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    @if (data.utilisateursDansAutreEntites && data.utilisateursDansAutreEntites.length > 0) {
      <div>
        <p class="dark:text-white">{{ 'USERS_MANAGEMENT.CONTACT_PILOT_MESSAGE' | translate }}</p>
        <ul class="dark:text-white">
          @for (user of data.utilisateursDansAutreEntites; track user) {
            <li>{{ user }}</li>
          }
        </ul>
      </div>
    }
    @if (data.utilisateursSucces && data.utilisateursSucces.length > 0) {
      <div>
        <p class="dark:text-white">{{ 'USERS_MANAGEMENT.SUCCESSFULLY_DEACTIVATED_USERS' | translate }}</p>
        <ul class="dark:text-white">
          @for (user of data.utilisateursSucces; track user) {
            <li>{{ user }}</li>
          }
        </ul>
      </div>
    }
  </div>
  <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end dark:bg-gray-700">
    <button mat-button color="warn" (click)="onClose()" class="px-4 py-2 btn-primary-novo dark:text-white">
      {{ 'USERS_MANAGEMENT.CLOSE' | translate }}
    </button>
  </div>
</div>
